var AuthorizerErrorCode = /* @__PURE__ */ ((AuthorizerErrorCode2) => {
  AuthorizerErrorCode2["NOT_IN_PACKAGE"] = "CNIP";
  AuthorizerErrorCode2["GOOGLE_PLAY_NOT_IN_PACKAGE"] = "CNIPGIABA";
  AuthorizerErrorCode2["NOT_AT_REGION"] = "CNAR";
  AuthorizerErrorCode2["CONCURRENCY_PER_USER"] = "SCLPU";
  AuthorizerErrorCode2["CONCURRENCY_PER_CHANNEL"] = "SCLPC";
  AuthorizerErrorCode2["CONCURRENCY_PER_PROVIDER"] = "SCLPP";
  AuthorizerErrorCode2["CONCURRENCY_PER_DEVICE"] = "SCDCA";
  AuthorizerErrorCode2["NOT_VALID_FORGEROCK_TOKEN"] = "NVFRT";
  AuthorizerErrorCode2["NOT_VALID_CUSTOMER_TOKEN"] = "NVCT";
  AuthorizerErrorCode2["NOT_VALID_ASSET_TOKEN"] = "NVAT";
  AuthorizerErrorCode2["NOT_VALID_REFRESH_TOKEN"] = "NVRT";
  AuthorizerErrorCode2["NOT_VALID_REFRESH_TOKEN_2"] = "NVRF";
  AuthorizerErrorCode2["REFRESH_TOKEN_REVOKED"] = "RRT";
  return AuthorizerErrorCode2;
})(AuthorizerErrorCode || {});

export { AuthorizerErrorCode };
//# sourceMappingURL=types.js.map
